import { FC } from 'react';
import { HiOutlinePencilAlt, HiOutlineTrash } from 'react-icons/hi';
import { itinaryProps } from '../../../../../../constants';

interface ItinaryCardProps extends itinaryProps {
  onEditHandler: () => void;
  onDeleteHandler: () => void;
}

const ItinaryCard: FC<ItinaryCardProps> = ({
  title,
  description,
  day,
  onDeleteHandler,
  onEditHandler,
}) => (
  <div className='bg-white dark:bg-gray-800 rounded-xl p-4 border border-gray-100 dark:border-gray-700 hover:shadow-md transition-shadow duration-200 h-full flex flex-col'>
    <div className='flex items-start gap-4 mb-3'>
      <div className='flex-shrink-0 w-8 h-8 flex items-center justify-center bg-primary-50 dark:bg-primary-900/20 text-primary-600 dark:text-primary-400 font-bold rounded-lg text-sm'>
        {day}
      </div>
      <div className='flex-1 min-w-0'>
        <h4 className='font-semibold text-sm text-gray-700 dark:text-gray-200 truncate'>{title}</h4>
        <div 
          className='text-sm text-gray-500 dark:text-gray-400 mt-1 line-clamp-2 prose prose-sm dark:prose-invert'
          dangerouslySetInnerHTML={{ __html: description }} 
        />
      </div>
    </div>

    <div className='flex justify-end gap-2 mt-auto pt-3 border-t border-gray-100 dark:border-gray-700/50'>
      <button
        type='button'
        onClick={onEditHandler}
        className='p-2 text-primary-600 hover:bg-primary-50 dark:text-primary-400 dark:hover:bg-primary-900/20 rounded-lg transition-colors'
        title='Edit'
      >
        <HiOutlinePencilAlt className='w-4 h-4' />
      </button>
      <button
        type='button'
        onClick={onDeleteHandler}
        className='p-2 text-rose-600 hover:bg-rose-50 dark:text-rose-400 dark:hover:bg-rose-900/20 rounded-lg transition-colors'
        title='Delete'
      >
        <HiOutlineTrash className='w-4 h-4' />
      </button>
    </div>
  </div>
);

export default ItinaryCard;
